<template>
    <div ref="ulSelect" class="custom-ul-select-parent">
        <select :name="name" v-show="false">
            <option :value="index" v-for="(item, index) in jsonValues">{{ item }}</option>
        </select>
        <div class="custom-ul-select">
            <div class="custom-ul-select-text" v-on:click="toggleSelect()">
                <span v-text="currentText"></span> <i :class="'fa fa-caret-' + (opened ? 'up' : 'down')"></i>
            </div>
            <div class="custom-ul-select-values" v-show="opened">
                <div :value="index" v-for="(item, index) in jsonValues" v-on:click="setOption(index, item)">{{ item }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'name', 'values', 'value'
        ],
        data: function () {
            let jsonValues   = this.values ? JSON.parse(this.values) : {};
            let currentValue = this.value && jsonValues[this.value] ? this.value : Object.keys(jsonValues)[0];

            return {
                opened: false,
                jsonValues: jsonValues,
                currentValue: currentValue,
                currentText: jsonValues[currentValue] ? jsonValues[currentValue] : ''
            }
        },
        mounted () {
            $('body [name=' + this.name + ']').val(this.currentValue);
            document.addEventListener('click', this.documentClick)
        },
        methods: {
            toggleSelect: function () {
                this.opened = !this.opened;
            },
            setOption: function (option, text) {
                this.currentValue = option;
                this.currentText  = text;
                $('body [name=' + this.name + ']').val(option);
                this.closeSelect();
            },
            closeSelect() {
                this.opened = false;
            },
            documentClick(e) {
                let el     = this.$refs['ulSelect'];
                let target = e.target;
                if (el !== target && !el.contains(target)) {
                    this.closeSelect()
                }
            }
        }
    }
</script>
